import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { hasCookie } from 'cookies-next'
import cx from 'classnames'

import TryFreeCta from '@/components/TryFreeCta'

import styles from './Popup.module.scss'

const Popup = ({
  postSlug = '',
  exitIntent = false,
}) => {
  const [showPopup, setShowPopup] = useState(false)
  const [showBtnPopup, setShowBtnPopup] = useState(false)
  const [isDismissed, setIsDismissed] = useState(false)
  const [popupBtnCentered, setPopupBtnCentered] = useState(true)

  const handleScroll = () => {
    if (window.scrollY > 1000 && !isDismissed) {
      setShowPopup(true)
    }
  }

  const handleMouseOut = (event) => {
    if (event.clientY < 10 && !isDismissed && exitIntent) {
      setShowPopup(true)
    }
  }

  const handleClose = () => {
    setShowPopup(false)
    setShowBtnPopup(true)
    setIsDismissed(true)
  }

  const handleOpen = () => {
    setShowPopup(true)
    setShowBtnPopup(false)
    setIsDismissed(false)
  }

  useEffect(() => {
    if (exitIntent) {
      document.addEventListener('mouseout', handleMouseOut)
    } else {
      window.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (exitIntent) {
        document.removeEventListener('mouseout', handleMouseOut)
      } else {
        window.removeEventListener('scroll', handleScroll)
      }
    }
  }, [isDismissed, exitIntent])

  useEffect(() => {
    // Reset state variables when postSlug changes
    setShowPopup(false)
    setShowBtnPopup(false)
    setIsDismissed(false)
  }, [postSlug])

  useEffect(() => {
    if (hasCookie('pm-cookie-consent')) return setPopupBtnCentered(false)

    const onConsent = () => {
      setPopupBtnCentered(false)
    }

    window.addEventListener('cookieConsentGiven', onConsent)

    return () => window.removeEventListener('cookieConsentGiven', onConsent)
  }, [])

  return (
    <div>
      {showPopup && (
        <div className={styles.popup}>
          <button className={styles.closePopupBtn} onClick={handleClose}>x</button>
          <div className={styles.popupContent}>
            <h3>Stay Tax-Ready with Smart Expense Tracking Software</h3>
            <p>Neat automatically organizes, and categorizes expenses so you're always prepared for tax season.</p>
            <TryFreeCta />
          </div>
        </div>
      )}
      {showBtnPopup && (
        <button className={cx(styles.btnPopup, popupBtnCentered && styles.centered)} onClick={handleOpen}>
          Be Tax-Ready, Track Expenses Now
        </button>
      )}
    </div>
  )
}

Popup.propTypes = {
  postSlug: PropTypes.string,
  exitIntent: PropTypes.bool,
}

export default Popup
